import XIcon from '@lib/images/icons/social-media/x.svg';
import instagramIcon from '@lib/images/icons/social-media/instagram.svg';
import youtubeIcon from '@lib/images/icons/social-media/youtube.svg';
import facebookIcon from '@lib/images/icons/social-media/facebook.svg';
import tiktokIcon from '@lib/images/icons/social-media/tiktok.svg';

const links: {
	name: string;
	links: {
		label: string;
		url: string;
		icon?: string;
		is_external?: boolean;
	}[];
}[] = [
	{
		name: 'Resources',
		links: [
			{
				label: 'Beranda',
				url: '/'
			},
			{
				label: 'Cari Buku',
				url: '/search'
			},
			{
				label: 'Redeem',
				url: '/redeem'
			}
		]
	},
	{
		name: 'Company',
		links: [
			{
				label: 'Tentang',
				url: '/about'
			},
			{
				label: 'Bantuan',
				url: '/help'
			},
			{
				label: 'Lokasi',
				url: '/location',
				is_external: true
			},
			{
				label: 'Kebijakan Privasi',
				url: '/privacy-policy'
			},
			{
				label: 'Syarat dan ketentuan',
				url: '/terms-conditions'
			}
		]
	},
	{
		name: 'Kontak Kami',
		links: [
			{
				label: 'Instagram',
				url: 'https://www.instagram.com/officialyapindo/',
				icon: instagramIcon
			},
			{
				label: 'Facebook',
				url: 'https://www.facebook.com/yapindo.official',
				icon: facebookIcon
			},
			{
				label: 'X',
				url: 'https://x.com/YapindoOfficial',
				icon: XIcon
			},
			{
				label: 'Youtube',
				url: 'https://www.youtube.com/channel/UCCB0CSx1gSljFashlMAoYTA',
				icon: youtubeIcon
			},
			{
				label: 'Tiktok',
				url: 'https://tiktok.com/@officialyapindo',
				icon: tiktokIcon
			}
		]
	}
];

export { links };
